import { useMutation, useQuery } from "@tanstack/react-query";
import AssesmentService from "../Service.js/AssesmentService";

const useGetFeedbackHeaderData = (config) => {
  const {
    params,
    onSuccess = () => null,
    enabled = true,
    queryKeyName = "feedbackHeaderData",
    ...queryConfigs
  } = config;
  const queryKey = [params?.interviewId];
  const query = useQuery({
    queryKey: [queryKeyName, queryKey],
    queryFn: async () => {
      const headerData = await AssesmentService.getAIInterviewDetails(
        params.interviewId
      );
      return headerData?.data?.data;
    },
    enabled,
    onSuccess,
    refetchOnWindowFocus: false,
    ...queryConfigs,
  });
  return query;
};

const useGetCandidateAssessment = (config) => {
  const {
    params,
    onSuccess = () => null,
    enabled = true,
    queryKeyName = "candidate_assessment",
    ...queryConfigs
  } = config;
  const queryKey = [params?.interviewId];
  const query = useQuery({
    queryKey: [queryKeyName, queryKey],
    queryFn: async () => {
      const headerData = await AssesmentService.getAiCandidateAssessments(
        params
      );
      return headerData?.data?.data;
    },
    enabled,
    onSuccess,
    refetchOnWindowFocus: false,
    ...queryConfigs,
  });
  return query;
};

const useGetCandidateAssessmentAnswer = (config) => {
  const {
    params,
    onSuccess = () => null,
    enabled = true,
    queryKeyName = "candidate_assessment_answer",
    ...queryConfigs
  } = config;
  const queryKey = [params?.interviewId];
  const query = useQuery({
    queryKey: [queryKeyName, queryKey],
    queryFn: async () => {
      const headerData = await AssesmentService.getAiCandidateAssessmentAnswers(
        params
      );
      return headerData?.data?.data;
    },
    enabled,
    onSuccess,
    refetchOnWindowFocus: false,
    ...queryConfigs,
  });
  return query;
};

const useGetInterviewTypeData = (config) => {
  const {
    params,
    onSuccess = () => null,
    enabled = true,
    queryKeyName = "interview_types",
    ...queryConfigs
  } = config;
  // const queryKey = [params];
  const query = useQuery({
    queryKey: [queryKeyName],
    queryFn: async () => {
      const headerData = await AssesmentService.getInterviewTypes(params);
      return headerData?.data?.data;
    },
    enabled,
    onSuccess,
    refetchOnWindowFocus: true,
    ...queryConfigs,
  });
  return query;
};

const useInitiatePayment = (config) => {
  const { handleOnSuccess, onError = () => null } = config;
  const mutation = useMutation({
    mutationFn: async ({ data, params = {} }) => {
      const details = await AssesmentService.getInitialtePayment(data, params);
      return details?.data?.data;
    },
    onSuccess: handleOnSuccess,
    onError,
  });
  return mutation;
};

const useScheduleInterview = (config) => {
  const { onSuccess, onError } = config;
  const query = useMutation({
    mutationFn: async ({ body, params = {} }) => {
      console.log(body, "paramsbody");
      console.log(params, "params");
      const mutationResponse = await AssesmentService.getScheduleInterview(
        body,
        params
      );
      return mutationResponse?.data?.data;
    },
    onSuccess,
    onError,
    refetchOnWindowFocus: false,
  });
  return query;
};

export const GET_PERSONALITY_REPORT = "GET_PERSONALITY_REPORT";
export const useGetPersonalityInterviewReport = (config) => {
  const { params, ...queryConfigs } = config;
  const query = useQuery({
    queryKey: [GET_PERSONALITY_REPORT, params?.id],
    queryFn: async () => {
      const details = await AssesmentService.getPersonalityInterviewReport(
        params?.id
      );
      return details?.data?.data;
    },
    refetchOnWindowFocus: false,
    ...queryConfigs,
  });
  return query;
};

export const GET_ASSESSMENT_LIST = "GET_ASSESSMENT_LIST";
export const useGetAssessmentList = (config) => {
  const { params, ...queryConfigs } = config;
  const query = useQuery({
    queryKey: [GET_ASSESSMENT_LIST],
    queryFn: async () => {
      const details = await AssesmentService.getAssessmentList();
      return details?.data?.data;
    },
    refetchOnWindowFocus: false,
    ...queryConfigs,
  });
  return query;
};

const useGetDreamRoleData = (config) => {
  const {
    params,
    onSuccess = () => null,
    enabled = true,
    queryKeyName = "dream_role_data",
    ...queryConfigs
  } = config;
  // const queryKey = [params];
  const query = useQuery({
    queryKey: [queryKeyName],
    queryFn: async () => {
      const headerData = await AssesmentService.getDreamRoleData(params);
      return headerData?.data?.data;
    },
    enabled,
    onSuccess,
    refetchOnWindowFocus: true,
    ...queryConfigs,
  });
  return query;
};

export {
  useGetFeedbackHeaderData,
  useGetCandidateAssessment,
  useGetCandidateAssessmentAnswer,
  useGetInterviewTypeData,
  useInitiatePayment,
  useScheduleInterview,
  useGetDreamRoleData
};
